<template lang="pug" src="./alerts.pug"></template>

<style rel="stylesheet/scss" lang="scss" scoped>
    @import "@/assets/styles/style-variables.scss";

    .errors {
        z-index: 999;
        position: fixed;
        bottom: 50px;
        right: 50px;
    }

    .slide-fade-enter-active {
        transition: all .6s ease;
    }
    .slide-fade-leave-active {
        transition: all .4s ease-in-out;
    }
    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(100px);
        opacity: 0;
    }
    .slide-fade-leave-to {
        transform: translateY(-50px);
    }

    ::v-deep .v-alert.success{
        background-color: $blackButtonColor!important;
        border-radius: 10px;

        .v-alert__icon  {
            color: $whiteColor!important;
        }

        .v-icon {
            color: $whiteColor!important;
        }
    }

    ::v-deep .v-alert.error{
        background-color: $darkRedColor!important;
        border-radius: 10px;

        .v-alert__icon  {
            color: $blackColor!important;
        }

        .v-icon {
            color: $blackColor!important;
            color: $whiteColor!important;
        }
    }
    @media only screen and (max-width: 500px) {
        .errors {
            left: 10px;
            right: 10px;
            top: 40px;
            bottom: auto;
        }
    }

</style>

<script>
import { mapState } from 'vuex'

export default {
    name: 'Alerts',
    data: () => ({

    }),
    computed: {
        ...mapState({
            items: state => state.api.messages
        })
    },
    methods: {
    }
}
</script>
